import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableNewComposeExperienceUrls from './tableNewComposeExperienceUrls';
import tableNewComposeExperienceMulticam from './tableNewComposeExperienceMulticam';
import tableComposeExperienceMulticamFiles from './tableComposeExperienceMulticamFiles';
import MapConfigFields from './formGroupComposeExperience/formGroupComposeExperienceMapConfigurationFields';
import MapPreview from './formGroupLiveSteps/formGroupStep4CamerasPresentation/formGroup12MapPreview';
import { IconType } from '../components/atoms/icon/icon';
import viewRelatedCEVods from './viewRelatedCEVods';
import tableNewComposeExperienceUrlsFromVod from './tableNewComposeExperienceUrlsFromVod';

export default {
  title: 'Details',
  attributeName: 'composeExperiencesDetails',
  refreshUpdate: false,
  fields: [    
    {
      attributeName: 'id',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'ID',
      hidden: true
    },
    {
      attributeName: 'composeExperienceType',
      type: FormInputTypes.SELECT,
      onChangeUrl: 'composeExperienceTypeChange',
      label: 'Media Type',
      enabledWhen:{"field":"id","values":"not-null"},
      helpText: '',
      options: [
        { name: 'Choose Media Type', value: 'undefined'},
        { name: 'Multicam', value: 'multicam' },
        { name: 'Url', value: 'url' },
        { name: 'From VoD', value: 'fromVod' },
        
      ]
    },    
     {
      attributeName: 'fromVodId',
      label: 'Vod Selected',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedCEVods,
      default: [],
      helpText: 'Vod related to this composed experience.',
      visibleWhen: {"field":"composeExperienceType","value":"fromVod"},
      disabledWhenEdit:true,
      blockItemRemove:true,
    },
     {
      attributeName: 'vodLink',
      label:'Vod link',
      type: FormInputTypes.LINK,
      icon: IconType.ARROW_RIGHT,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Link to the corresponding Vod.',
      visibleWhenEdit:true,
      visibleWhen: {"field":"composeExperienceType","value":"fromVod"}
    },   
    {
      attributeName: 'composeExperiencesUrls',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableNewComposeExperienceUrls,
      visibleWhen: [{"field":"composeExperienceType","value":"url"}],
    },
    {
      attributeName: 'composeExperiencesUrls',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableNewComposeExperienceUrlsFromVod,
      visibleWhen: [{"field":"composeExperienceType","value":"fromVod"}],
    },
    {
      attributeName: 'composeExperenceLabels',
      type: FormInputTypes.TEXT,
      label:'Composed Experience Multicam Files',
      helpText: '',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"}
    },
    {
      attributeName: 'composeExperiencesUrls',
      type: FormInputTypes.TABLE,
      canEdit:false,
      label:'Composed Experience Files',
      helpText: '',
      configFile: tableComposeExperienceMulticamFiles,
      visibleWhen: {"field":"composeExperienceType","value":"multicam"}
    },
    {
      attributeName: 'VoDs',
      type: FormInputTypes.TEXT,
      label:'VoDs in ',
      helpText: '',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"}
    },
    {
      attributeName: 'composeExperienceMulticamComposer',
      type: FormInputTypes.TABLE,
      canEdit:false,
      label: '',
      helpText: '',        
      parentData: true,
      configFile: tableNewComposeExperienceMulticam,
      visibleWhen: {"field":"composeExperienceType","value":"multicam"}
    },      
    {
      attributeName: 'cameras',
      type: FormInputTypes.CAMERAS_PRESENTATION,
      emptyMessage: "You don't have any view point yet.",
      label: 'Cameras',
      itemLabel:'Cameras',
      required: false,
      helpText: 'Insert new view points clicking in + button.',
      errorText: '',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"}
    },
    {
      attributeName: 'importButton',
      label: 'Create Live from template',
      type: FormInputTypes.BUTTON_POPUP,
      icon: IconType.NEW,
      buttonText:"Import Images from Settings",
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Create new Live from this template.',
      // redirectUrl:'lives',
      actionUrl:'liveSettingsSelected',
      isEditId:true,
      visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      formConfig:
        {
          title: 'Import Images from Live Settings',
          description:'You can get the hole set of images from Settings to fill all images in a row',
          attributeName: 'newImageSettings',
          fields: [
            {
              attributeName: 'importSettings',
              helpText: 'Select a valid Image settings to be imported on this popup',
              type: FormInputTypes.SELECT,
              label: 'Import Image Settings From',
              placeholder: 'Please enter a valid image setting',
              multiple: false,
              url: 'liveSettingsList',
              validateUrl:'liveSettingsValidate/liveId',
              emptyValue:true,
              default:'(Empty)', //default value to empty option
              fieldValue:'id',
              fieldName:'name',
              asyncSelect: true,
              options:[],
              sessionParams: ['liveId'],

            },
          ]
        }
    }, 
    {
      attributeName: 'mapConfig',
      type: FormInputTypes.JSON_COMPONENT,
      canCreate:false,
      canRemove:false,
      emptyMessage: "You don't have any map config, click on the +new button to make a new one.",
      avoidPopupSockets: true,
      columns:1,
      items:1,
      label: 'Map configuration',
      itemLabel:'Map config',
      required: true,
      helpText: 'Insert new map config.',
      errorText: '',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      popupFormGroups:[
        MapConfigFields,
      ]
    },
    {
      attributeName: 'positionOffsetX',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Position offset X',
      required: true,
      className:'col-sm-4',
      default:"0.0",
      helpText: 'Set the offset pos x.',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      errorText: '',
    },
    {
      attributeName: 'positionOffsetY',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Position offset Y',
      required: true,
      className:'col-sm-4',
      default:"0.0",
      helpText: 'Set the offset pos y.',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      errorText: '',
    },
    {
      attributeName: 'positionOffsetZ',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Position offset Z',
      required: true,
      className:'col-sm-4',
      default:"0",
      helpText: 'Set the offset pos z.',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      errorText: '',
    },
    {
      attributeName: 'rotationOffsetX',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Rotation offset X',
      required: true,
      className:'col-sm-4',
      default:"0",
      helpText: 'Set the panel rot x.',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      errorText: '',
    },
    {
      attributeName: 'rotationOffsetY',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Rotation offset Y',
      required: true,
      className:'col-sm-4',
      default:"0",
      helpText: 'Set the panel rot Y.',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      errorText: '',
    },
    {
      attributeName: 'rotationOffsetZ',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Rotation offset Z',
      required: true,
      className:'col-sm-4',
      default:"0",
      helpText: 'Set the panel rot z.',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      errorText: '',
    },
    {
      attributeName: 'scale',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Scale',
      required: true,
      className:'col-sm-4',
      default:"1",
      helpText: 'Set the scale.',
      visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      errorText: '',
    },

    
  ],
};
